import { render, staticRenderFns } from "./PuzzleButton.vue?vue&type=template&id=134d2399&scoped=true&"
import script from "./PuzzleButton.vue?vue&type=script&lang=js&"
export * from "./PuzzleButton.vue?vue&type=script&lang=js&"
import style0 from "./PuzzleButton.vue?vue&type=style&index=0&id=134d2399&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134d2399",
  null
  
)

export default component.exports